import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { TranslatorContext } from "../../../context/Translator";
import { Row, Col } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";

export default function ProductShowPage() {
    const { t } = useContext(TranslatorContext);
    const { id } = useParams(); // get product id from URL
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/products-show/${id}`)
            .then(res => {
                if (res.data && res.data.products) {
                    setProduct(res.data.products);
                }
            })
            .catch(err => {
                console.error("Error fetching product:", err);
            })
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) return <PageLayout><p>{t('loading')}...</p></PageLayout>;
    if (!product) return <PageLayout><p>{t('product_not_found')}</p></PageLayout>;

    return (
        <PageLayout>
            <div className="mc-card mb-4" >
                <div className="mc-breadcrumb d-flex justify-content-between align-items-center">

                    <div>
                        <h3 className="mc-breadcrumb-title">{t('product_view')}</h3>
                        <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item">
                                <Link to='/' className="mc-breadcrumb-link">{t('home')}</Link>
                            </li>
                            <li className="mc-breadcrumb-item">
                                <Link to='/products' className="mc-breadcrumb-link">{t('products')}</Link>
                            </li>
                            <li className="mc-breadcrumb-item">{product.name}</li>
                        </ul>
                    </div>

                    {/* RIGHT SIDE: Back Button */}
                    <Link
                        to="/products-list"
                        className="btn btn-primary d-flex align-items-center"
                    >
                        <span className="material-icons me-1">arrow_back</span>
                        {t('back_to_all_products')}
                    </Link>

                </div>
            </div>

            <div className="mc-card p-lg-4">
                <Row>
                    <Col xl={5}>
                        <h6 className="mc-divide-title mb-4">{t('product_gallery')}</h6>
                        <div className="mc-product-view-gallery">
                            {(() => {
                                const images = [];

                                if (product.card_img) {
                                    images.push(`${process.env.REACT_APP_IMG_URL}${product.card_img}`);
                                }

                                if (product.detail_img) {
                                    const detailImages =
                                        typeof product.detail_img === "string"
                                            ? JSON.parse(product.detail_img)
                                            : product.detail_img;

                                    if (Array.isArray(detailImages)) {
                                        detailImages.forEach((img) => {
                                            images.push(`${process.env.REACT_APP_IMG_URL}${img}`);
                                        });
                                    }
                                }

                                if (images.length === 0) {
                                    images.push("images/product/single/01.webp");
                                }

                                return images.map((img, index) => (
                                    <img
                                        key={index}
                                        src={img}
                                        alt={`product-${index}`}
                                        style={{ width: "100%", marginBottom: "10px" }}
                                    />
                                ));
                            })()}
                        </div>
                    </Col>

                    <Col xl={7}>
                        <h6 className="mc-divide-title mb-4">{t('product_details')}</h6>
                        <div className="mc-product-view-info-group">
                            <h2 className="mc-product-view-info-title">{product.name}</h2>
                            <div className="mc-product-view-meta">
                                <h5>{t('category')}</h5>
                                <span>:</span>
                                <p>{product.category?.name}</p>
                            </div>
                            <div className="mc-product-view-meta">
                                <h5>{t('details')}</h5>
                                <span>:</span>
                                <div
                                    className="product-rich-content"
                                    dangerouslySetInnerHTML={{
                                        __html: product.details || `<em>${t('No details available')}</em>`
                                    }}
                                />

                            </div>
                            <div className="mc-product-view-meta">
                                <h5>{t('online available')}</h5>
                                <span>:</span>
                                <p>{product.is_online ? t('available') : t('not_available')}</p>
                            </div>
                        </div>
                    </Col>


                </Row>
            </div>
        </PageLayout>
    );
}